<form class="p-6">
  <div class="flex flex-col gap-4">
    <div class="flex flex-col xl:flex-row gap-3 justify-between">
      <div>
        <span class="flex justify-start items-center text-black font-black uppercase">Controle de Módulos</span>
        <p class="mt-1 text-sm text-gray-500">
          Módulos inativos não aparecem para seleção em novos setups nem retornam no endpoint padrão de módulos.
        </p>
      </div>

      <div class="flex justify-start lg:justify-end flex-wrap gap-2">
        <app-status-filter [formControl]="statusControl"></app-status-filter>

        <input
          [formControl]="searchControl"
          type="text"
          class="form-input w-64"
          placeholder="Pesquisar por nome ou rota"
        />

        <button
          type="button"
          (click)="cleanFilters()"
          title="Limpar filtros"
          class="px-5 min-w-max btn btn--primary h-35 bg-blumine"
        >
          <img class="w-6 h-6" src="./assets/icons/backspace_white.svg" alt="limpar" />
        </button>

        <button
          type="button"
          (click)="getModules()"
          title="Recarregar módulos"
          class="px-5 min-w-max btn btn--secondary h-35"
        >
          <mat-icon class="text-white">refresh</mat-icon>
        </button>
      </div>
    </div>

    <div class="bg-white rounded-2xl shadow-md overflow-hidden">
      <div *ngIf="loading" class="p-8 text-center text-gray-500">Carregando módulos...</div>

      <div *ngIf="!loading" class="overflow-x-auto">
        <table class="w-full min-w-[900px] text-left">
          <thead class="bg-iceberg text-chathams-blue uppercase text-xs font-bold">
            <tr>
              <th class="px-5 py-3">Módulo</th>
              <th class="px-5 py-3">Rota</th>
              <th class="px-5 py-3">Configurações</th>
              <th class="px-5 py-3">Status</th>
              <th class="px-5 py-3 text-right">Ações</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let module of filteredModules" class="border-t border-iceberg hover:bg-gray-50">
              <td class="px-5 py-4">
                <div class="font-bold text-chathams-blue">{{ module.name }}</div>
                <div class="text-xs text-gray-400">{{ module.id }}</div>
              </td>
              <td class="px-5 py-4 text-sm text-gray-700">{{ module.route }}</td>
              <td class="px-5 py-4">
                <div class="flex items-center gap-3 text-chathams-blue">
                  <mat-icon matTooltip="Requer autenticação" *ngIf="module.requiresAuth">login</mat-icon>
                  <mat-icon matTooltip="Requer triagem" *ngIf="module.requiresTriage">checklist</mat-icon>
                  <mat-icon matTooltip="Permite múltiplas conexões" *ngIf="module.multipleConnections"
                    >account_tree</mat-icon
                  >
                  <span
                    *ngIf="!module.requiresAuth && !module.requiresTriage && !module.multipleConnections"
                    class="text-sm text-gray-400"
                  >
                    Sem flags
                  </span>
                </div>
              </td>
              <td class="px-5 py-4">
                <span
                  [ngClass]="module.active ? 'bg-green-100 text-green-700' : 'bg-red-100 text-red-700'"
                  class="rounded-full px-3 py-1 text-xs font-bold"
                >
                  {{ module.active ? 'Ativo' : 'Inativo' }}
                </span>
              </td>
              <td class="px-5 py-4 text-right">
                <button
                  *isAllowed="[
                    ERoleAdminString.Master,
                    ERoleAdminString.Admin,
                    ERoleAdminString.Manager,
                    module.active ? 'module.disable' : 'module.enable'
                  ]"
                  type="button"
                  (click)="toggleActive(module)"
                  [ngClass]="module.active ? 'btn--primary bg-red-600' : 'btn--secondary'"
                  class="btn h-9 px-4 min-w-[110px]"
                >
                  {{ module.active ? 'Desativar' : 'Ativar' }}
                </button>
              </td>
            </tr>
          </tbody>
        </table>

        <div *ngIf="filteredModules.length === 0" class="p-8 text-center text-gray-500">Nenhum módulo encontrado.</div>
      </div>
    </div>
  </div>
</form>
